<div class="row">
    <div class="col">
        <div
            class="menu-entry cursor-pointer py-2 ps-3 pe-2"
            (click)="model.action()"
            [ngClass]="{ disabled: model.disabled }"
        >
            <fa-icon class="me-2" *ngIf="model.icon" [icon]="model.icon"></fa-icon> {{ model.title }}
        </div>
    </div>
</div>
